import instance from "../utils/request.js"
import { getRequest } from "../utils/request.js"

/*获取账单信息*/
export function GetBillingmanage(data = {}){
return instance.request({
        method: "get",
        url: "billingmanage/billingmanageFactory/",
        params:data
    })
}

/*获取账单编辑信息*/
export function BillingmanageEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "billingmanage/billingmanageFactoryedit/",
        params:data
    })
}

/*账单编辑*/
export function BillingmanageEdit(data = {}){
    let params = new URLSearchParams();
     params.append('billingmanageid',data.billingmanageid);
    params.append('weightfee',data.weightfee);
    params.append('copyfeeout',data.copyfeeout);
    params.append('samplefeeout',data.samplefeeout);
    params.append('silverprice',data.silverprice);
    params.append('laborcostsout',data.laborcostsout);
return instance.request({
        method: "post",
        url: "billingmanage/billingmanageFactoryedit/",
        data:params
    })
}

/*导出发货对账信息*/
export function ExportBillingmanage(data = {}){
return instance.request({
        method: "post",
        url: "billingmanage/billingmanageFactoryexport/",
        data:data,
        responseType: 'blob',
        timeout:30000
    })
}

export function GetOrdercategory(data = {}){
return instance.request({
        method: "get",
        url: "billingmanage/getordercategory/",
        params:data
    })
}
/*获取账单类型*/
